import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { useGeneratePreSignatureFileMutationMutation } from "./graphql/GeneratePreSignatureFileMutation.v5.generated";
/**
 * @deprecated This hook is deprecated and will be removed in the next major version.
 * Use the `useEncryptedPreSignatureFile` hook instead from @crehana/react-hooks/file-upload
 */
var usePreSignatureFile = function usePreSignatureFile(organizationId) {
  var _useGeneratePreSignat = useGeneratePreSignatureFileMutationMutation({
      context: {
        clientName: 'v5'
      }
    }),
    _useGeneratePreSignat2 = _slicedToArray(_useGeneratePreSignat, 2),
    getSignature = _useGeneratePreSignat2[0],
    _useGeneratePreSignat3 = _useGeneratePreSignat2[1],
    loading = _useGeneratePreSignat3.loading,
    error = _useGeneratePreSignat3.error;
  var createPreSignature = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, options) {
      var _response$data, _response$data$file_u, _response$data$file_u2;
      var response, _response$data$file_u3, fields, url, fileId, payload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSignature({
              variables: {
                input: _objectSpread({
                  organization_id: organizationId
                }, options)
              },
              onError: function onError() {
                return null;
              }
            });
          case 2:
            response = _context.sent;
            if (!(!response || ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$file_u = _response$data.file_upload) === null || _response$data$file_u === void 0 ? void 0 : (_response$data$file_u2 = _response$data$file_u.generate_presigned) === null || _response$data$file_u2 === void 0 ? void 0 : _response$data$file_u2.__typename) !== 'S3PresignDataFields')) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", {
              success: false
            });
          case 5:
            _response$data$file_u3 = response.data.file_upload.generate_presigned.data_s3, fields = _response$data$file_u3.fields, url = _response$data$file_u3.url;
            fileId = response.data.file_upload.generate_presigned.file_id;
            if (!(fields && typeof fields === 'object')) {
              _context.next = 10;
              break;
            }
            payload = [{
              fieldName: 'acl',
              fieldValue: 'acl' in fields && typeof fields.acl === 'string' ? fields.acl : ''
            }, {
              fieldName: 'Content-Type',
              fieldValue: 'Content-Type' in fields && typeof fields['Content-Type'] === 'string' ? fields['Content-Type'] : ''
            }, {
              fieldName: 'key',
              fieldValue: 'key' in fields && typeof fields.key === 'string' ? fields.key : ''
            }, {
              fieldName: 'AWSAccessKeyId',
              fieldValue: 'AWSAccessKeyId' in fields && typeof fields.AWSAccessKeyId === 'string' ? fields.AWSAccessKeyId : ''
            }, {
              fieldName: 'policy',
              fieldValue: 'policy' in fields && typeof fields.policy === 'string' ? fields.policy : ''
            }, {
              fieldName: 'signature',
              fieldValue: 'signature' in fields && typeof fields.signature === 'string' ? fields.signature : ''
            }];
            return _context.abrupt("return", {
              success: true,
              payload: payload,
              url: url,
              file: file,
              fileId: fileId
            });
          case 10:
            return _context.abrupt("return", {
              success: false
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [organizationId, getSignature]);
  return {
    loading: loading,
    error: !!error,
    createPreSignature: createPreSignature
  };
};
export default usePreSignatureFile;